import React from 'react';
import { BadgePercent, KeyRound } from 'lucide-react';

// Small product emblem so a mortgage opportunity and a real-estate
// opportunity can be told apart at a glance — on Board cards, the alerts
// strip, and the contact-profile opportunity list. Same icon set (lucide)
// as the rest of the portal: rate badge for mortgage, key for real estate.
//
//   product     'mortgage' | 'real_estate'  (unknown → renders nothing)
//   size        icon px (default 14)
//   decorative  true when the emblem sits next to visible text that already
//               names the product (e.g. the board switcher) — hides it from
//               screen readers instead of reading the label twice.
export const EMBLEMS = {
  mortgage: { Icon: BadgePercent, label: 'Mortgage opportunity', color: '#070B5F', bg: '#E8EAF6' },
  real_estate: { Icon: KeyRound, label: 'Real estate opportunity', color: '#6BA82E', bg: '#EEF7E4' },
};

export default function OpportunityEmblem({ product, size = 14, decorative = false, className = '' }) {
  const e = EMBLEMS[product];
  if (!e) return null;
  const { Icon } = e;
  const a11y = decorative
    ? { 'aria-hidden': true }
    : { role: 'img', 'aria-label': e.label, title: e.label };
  return (
    <span
      {...a11y}
      data-testid="opportunity-emblem"
      data-product={product}
      className={`inline-flex items-center justify-center rounded-full flex-shrink-0 ${className}`}
      style={{ width: size + 8, height: size + 8, background: e.bg, color: e.color }}
    >
      <Icon size={size} strokeWidth={2.25} aria-hidden="true" />
    </span>
  );
}
